(function () {
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  }

  function init() {
    if (document.querySelector('.sob-sticky-atc')) return;

    var realButton = document.querySelector('main [id^="ProductSubmitButton-"]');
    var priceEl = document.querySelector('main .price__container');
    var titleEl = document.querySelector('main .product__title h1');
    if (!realButton || !priceEl) return;

    var bar = document.createElement('div');
    bar.className = 'sob-sticky-atc';
    bar.innerHTML =
      '<div class="sob-sticky-atc__inner page-width">' +
      '<div class="sob-sticky-atc__info">' +
      '<span class="sob-sticky-atc__title"></span>' +
      '<span class="sob-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="button sob-sticky-atc__btn"></button>' +
      '</div>';
    document.body.appendChild(bar);

    var titleSpan = bar.querySelector('.sob-sticky-atc__title');
    var priceSpan = bar.querySelector('.sob-sticky-atc__price');
    var btn = bar.querySelector('.sob-sticky-atc__btn');

    function syncTitle() {
      titleSpan.textContent = titleEl ? titleEl.textContent.trim() : document.title;
    }

    function syncPrice() {
      var text = priceEl.textContent.trim().replace(/\s+/g, ' ');
      var match = text.match(/[\d.,]+\s?[A-Z€$£]+/);
      priceSpan.textContent = match ? match[0] : text;
    }

    function syncButtonState() {
      btn.disabled = !!realButton.disabled;
      btn.textContent = realButton.textContent.trim();
    }

    syncTitle();
    syncPrice();
    syncButtonState();

    new MutationObserver(syncPrice).observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    new MutationObserver(syncButtonState).observe(realButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    btn.addEventListener('click', function () {
      realButton.click();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', pastButton);
          });
        },
        { threshold: 0 }
      );
      io.observe(realButton);
    }
  }
})();
